import "./style.css";

const HeaderFilter = (props) => {
	return (
		<header className="header-filter border-bottom gap-2">
			<span className="title">{props.title}</span>
			<h6 className="text-xs border-botton mt-3 text-secondary">Pesquisar por..</h6>
		</header>
	);
};

export default HeaderFilter;
